import { SubmitDisclaimerRequest } from 'static/models/SubmitDisclaimerRequest';

import productServiceClient from '../apis/productServiceClient';
import { sendRequest } from '../web-request-tools';

export async function submitDisclaimerRequest(data: SubmitDisclaimerRequest): Promise<string> {
    return await sendRequest(productServiceClient.post<string>(`/disclaimer/${data.opportunityId}`, data));
}
